<template>
  <div class="Container">

    <img
      class="right"
      style="height: 40px;margin-top: 20px;"
      src="../../../assets/rank/top.png"
      alt=""
    />

    <div class="top123">
      <div class="noLight"></div>
      <van-row style="width: 100%;">
        
        <van-col span="8" style="margin-top: 40px;" >
          <div class="no">
            <img src="../../../assets/rank/2-3.png" class="noBg" alt="" />
            <img
             v-if="false"
              src="../../../assets/rank/2.png"
              style="width: 65px"
              class="noLTImg"
              alt=""
            />
            <img :src="rankSliver.headUrl" class="noAvatar" alt="" />
            <img src="../../../assets/rank/2-4.png" class="noAvatarBg" alt="" />
            <img src="../../../assets/rank/2-1.png" class="noHat" alt="" />
            <img src="../../../assets/rank/2-2.png" class="noRank" alt="" />
            <div class="noName">{{ rankSliver.nickname }}</div>
            <div class="noCount">{{ rankSliver.payNum }}</div>
          </div>
        </van-col>

        <van-col span="8">
          <div class="no">
            <img src="../../../assets/rank/1-3.png" class="noBg" alt="" />
       
            <img :src="rankGold.headUrl" class="noAvatar" alt="" />
            <img src="../../../assets/rank/1-4.png" class="noAvatarBg" alt="" />
            <img src="../../../assets/rank/1-1.png" class="noHat" alt="" />
            <img src="../../../assets/rank/1-2.png" class="noRank" alt="" />
            <img
              v-if="false"
              src="../../../assets/rank/1.png"
              style="width: 40px"
              class="noRTImg"
              alt=""
            />
            <div class="noName">{{ rankGold.nickname }}</div>
            <div class="noCount">{{ rankGold.payNum }}</div>
          </div>
        </van-col>

        <van-col span="8" style="margin-top: 40px;" >
          <div class="no">
            <img src="../../../assets/rank/3-3.png" class="noBg" alt="" />
            <img :src="rankBronze.headUrl" class="noAvatar" alt="" />
            <img src="../../../assets/rank/3-4.png" class="noAvatarBg" alt="" />
            <img src="../../../assets/rank/3-1.png" class="noHat" alt="" />
            <img src="../../../assets/rank/3-2.png" class="noRank" alt="" />
            <img
              v-if="false"
              src="../../../assets/rank/3.png"
              style="width: 65px"
              class="noRTImg2"
              alt=""
            />
            <div class="noName">{{ rankBronze.nickname }}</div>
            <div class="noCount">{{ rankBronze.payNum }}</div>
          </div>
        </van-col>
      </van-row>
    </div>



    <div class="itemContainer">
      <div v-for="item in rankList" :key="item.index" class="item">
        <div class="itemIndex ml16">{{ item.index }}</div>
        <img class="itemAvatar ml16" src="../../../assets/avatar.png" alt="" />
        <div class="itemName ml25">{{ item.nickname }}</div>
        <div class="itemCount">
          <div>{{ item.payNum }}</div>
          <div>充值次数</div>
        </div>
      </div>
    </div>
    <div class="t2 left ml16 mr16" style="margin-top: 10px">
      活动时间：{{ rankInfo.startDate }}至{{ rankInfo.endDate }}
    </div>
    <div class="t2 left ml16 mr16" style="margin-top: 10px">
      活动规则
      <br />1.该活动只限代理商用户参加，根据直邀用户会员类型的充值次数进行排名
      <br />2.在活动周期内直邀用户的充值次数前三名获得现金奖励
      <br />3.奖励金额：第一名2000元、第二名1000元、第三名500元
      <br />4.若出现恶意刷单及违规操作行为，奖励清零，最终归属权为"易元剪辑"所有
    </div>

    <div class="btn row">
      <img :src="rankInfo.headUrl" class="btnAvatar ml16" alt="" />
      <div class="ml25 column btnText">
        <div>{{ rankInfo.nickname }}</div>
        <div>充值次数：{{ rankInfo.payNum }}</div>
      </div>
      <div class="btnInvite" @click="toInvite">去邀请</div>
    </div>
    <div class="btmText right">充值次数相同根据时间先后做顺序</div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      rankInfo: {},
      rankGold: {},
      rankList: [],
      rankSliver: {},
      rankBronze: {},
    };
  },
  mounted() {
    let token = this.$route.query.juhaotui_token;
    if (token) {
      localStorage.setItem("token", token);
      this.$store.commit("setToken", token);
    }

    this.loadData();
  },

  methods: {
    loadData() {
      this.$request.GET({
        url: "/activity/first/pay/detail",
        success: (obj) => {
          this.rankInfo = obj.rankInfo;
          let list = this.rankInfo.rankList;
          this.rankGold = list.shift();
          this.rankSliver = list.shift();
          this.rankBronze = list.shift();
          this.rankList = list;
        },
      });
    },

    toInvite() {
      window.Android.open("/subcontract/pages/invite/invite").then(
        (response) => {
          console.log(response);
        }
      );
    },
  },
};
</script>
  
  <style scoped>
.Container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(../../../assets/rank/bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.top123 {
  width: 100%;
  margin-top: 15px;
  height: 250px;
  position: relative;
}
.no {
  position: relative;
}
.noLight {
  position: absolute;
  left: 0;
  right: 0;
  top: -80px;
  margin: auto;
  width: 260px;
  height: 260px;
  background-image: url(../../../assets/rank/1-light.png);
  background-repeat: no-repeat;
  background-size: contain;
}

.noBg {
  width: 100%;
  height: 205px;
}
.noLTImg {
  position: absolute;
  left: -10px;
  top: -10px;
}
.noRTImg {
  position: absolute;
  right: 0px;
  top: -20px;
}
.noRTImg2 {
  position: absolute;
  right: -20px;
  top: -20px;
}

.noAvatar {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  margin: auto;
  height: 56px;
  width: 56px;
  border-radius: 50%;
}
.noAvatarBg {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  margin: auto;
  width: 64px;
}
.noHat {
  position: absolute;
  left: 30px;
  top: -20px;
  width: 40px;
}
.noRank {
  height: 30px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  margin: auto;
}
.noName {
  position: absolute;
  top: 85px;
  left: 0;
  right: 0;
  margin: auto;
  font-family: Source Han Sans SC;
  font-weight: bold;
  font-size: 14px;
  color: #1e1e1e;
}
.noCount {
  position: absolute;
  top: 110px;
  left: 0;
  right: 0;
  margin: auto;
  font-family: YouSheBiaoTiYuan;
  font-weight: 700;
  font-size: 34px;
  color: #1e1e1e;
}
.itemContainer {
  width: 100%;
  max-height: 280px;
  overflow: scroll;
}
.item {
  padding-bottom: 15px;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.itemIndex {
  font-size: 20px;
  color: #1e1e1e;
  font-family: Source Han Sans SC;
  font-weight: 700;
}
.itemAvatar {
  width: 45px;
  height: 45px;
}

.itemName {
  font-size: 15px;
  color: #1e1e1e;
  font-family: Source Han Sans SC;
  font-weight: 500;
}

.itemCount {
  position: absolute;
  right: 20px;
  font-size: 13px;
  color: #1e1e1e;
  font-family: Source Han Sans SC;
  font-weight: 500;
  line-height: 15px;
}

.btn {
  position: relative;
  height: 78px;
  width: calc(100% - 32px); /* 16px * 2 = 32px */
  margin: 10px auto; /* 自动计算左右边距，居中显示 */
  background-image: url(../../../assets/rank/btn.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.btnAvatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}
.btnInvite {
  width: 100px;
  height: 40px;
  background: #ffffff;
  border-radius: 32px;
  font-size: 14px;
  font-weight: 500;
  color: #181818;
  text-align: center;
  line-height: 40px;
  position: absolute;
  right: 20px;
}

.btnText {
  font-size: 13px;
  color: white;
  font-weight: 500;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.t1 {
  font-size: 13px;
  color: #1e1e1e;
  font-family: Source Han Sans SC;
  font-weight: 500;
}

.t2 {
  font-size: 13px;
  color: #4c4b4b;
  font-family: Source Han Sans SC;
  font-weight: 500;
  text-align: left;
  line-height: 20px;
}

.left {
  align-self: flex-start;
}
.right {
  align-self: flex-end;
}

.mt40 {
  margin-top: 40px;
}

.mt30 {
  margin-top: 30px;
}
.mr16 {
  margin-right: 16px;
}
.ml16 {
  margin-left: 16px;
}
.ml20 {
  margin-left: 20px;
}
.ml25 {
  margin-left: 25px;
}
.btmText {
  margin-right: 16px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 12px;
  color: #181818;
  line-height: 12px;
  padding-bottom: 12px;
}
</style>